/* ==========================================================================
   Noirelle — theme.js
   Vanilla JS, no dependencies.
   ========================================================================== */
(function () {
  'use strict';

  var theme = window.theme || { routes: {}, strings: {}, delivery: {} };
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var mq = function (query) { return window.matchMedia(query).matches; };

  /* ------------------------------------------------------------------
     Announcement bar (rotates on small screens)
     ------------------------------------------------------------------ */
  function initAnnouncement(root) {
    $$('[data-announcement]', root).forEach(function (bar) {
      if (bar.dataset.ready) return;
      bar.dataset.ready = '1';
      var items = $$('.announcement__item', bar);
      if (items.length < 2) return;
      var speed = parseInt(bar.dataset.speed, 10) || 5000;
      var index = 0;
      setInterval(function () {
        if (mq('(min-width: 990px)') || document.hidden) return;
        items[index].classList.remove('is-active');
        index = (index + 1) % items.length;
        items[index].classList.add('is-active');
      }, speed);
    });
  }

  /* ------------------------------------------------------------------
     Header
     ------------------------------------------------------------------ */
  function initHeader() {
    var header = $('[data-header]');
    if (!header) return;
    var ticking = false;
    var update = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
      ticking = false;
    };
    update();
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
  }

  /* ------------------------------------------------------------------
     Drawers (menu + cart)
     ------------------------------------------------------------------ */
  var lastFocus = null;

  function openDrawer(id) {
    var drawer = document.getElementById(id);
    if (!drawer) return false;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    $$('[aria-controls="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var panel = $('.drawer__panel', drawer);
    window.setTimeout(function () { if (panel) panel.focus({ preventScroll: true }); }, 60);
    return true;
  }

  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open')) document.body.classList.remove('is-locked');
    $$('[aria-controls="' + drawer.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-drawer-open]');
    if (opener) {
      var id = opener.getAttribute('data-drawer-open');
      if (document.getElementById(id)) {
        event.preventDefault();
        openDrawer(id);
      }
      return;
    }
    var closer = event.target.closest('[data-drawer-close]');
    if (closer) {
      closeDrawer(closer.closest('[data-drawer]'));
      return;
    }
    var navLink = event.target.closest('.mobile-nav__link');
    if (navLink) closeDrawer(navLink.closest('[data-drawer]'));
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var open = $('.drawer.is-open');
    if (open) closeDrawer(open);
  });

  /* ------------------------------------------------------------------
     Cart (Shopify AJAX API + Section Rendering API)
     ------------------------------------------------------------------ */
  var cart = {
    sectionId: 'cart-drawer',

    request: function (url, options) {
      return fetch(url, options).then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok || data.status) {
            throw new Error(data.description || data.message || theme.strings.error);
          }
          return data;
        });
      });
    },

    add: function (formData) {
      formData.append('sections', this.sectionId);
      formData.append('sections_url', window.location.pathname);
      return this.request(theme.routes.cartAdd + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      });
    },

    change: function (line, quantity) {
      return this.request(theme.routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity, sections: [this.sectionId], sections_url: window.location.pathname })
      });
    },

    render: function (sections) {
      var html = sections && sections[this.sectionId];
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-cart-drawer-content]');
      var current = document.querySelector('[data-cart-drawer-content]');
      if (fresh && current) {
        current.replaceWith(fresh);
        this.updateCount(parseInt(fresh.dataset.itemCount, 10) || 0);
      }
    },

    updateCount: function (count) {
      $$('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.classList.toggle('is-empty', count === 0);
        el.classList.remove('is-bumped');
        void el.offsetWidth;
        el.classList.add('is-bumped');
      });
    }
  };
  window.NoirelleCart = cart;

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-cart-change]');
    if (!button) return;
    event.preventDefault();
    var line = parseInt(button.dataset.cartChange, 10);
    var quantity = Math.max(0, parseInt(button.dataset.quantity, 10) || 0);
    var drawer = button.closest('[data-cart-drawer]');
    if (!drawer) {
      cart.change(line, quantity).then(function () { window.location.reload(); }).catch(function (error) { window.alert(error.message); });
      return;
    }
    drawer.classList.add('is-loading');
    cart.change(line, quantity)
      .then(function (data) { cart.render(data.sections); })
      .catch(function (error) { console.error(error); })
      .finally(function () { drawer.classList.remove('is-loading'); });
  });

  /* ------------------------------------------------------------------
     Lightbox
     ------------------------------------------------------------------ */
  var lightbox = null;
  function openLightbox(src, alt) {
    if (!lightbox) {
      lightbox = document.createElement('dialog');
      lightbox.className = 'lightbox';
      lightbox.innerHTML =
        '<button type="button" class="icon-button lightbox__close" aria-label="' + (theme.strings.close || 'Close') + '">' +
        '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" aria-hidden="true"><path d="M5.5 5.5l13 13M18.5 5.5l-13 13"/></svg></button><img alt="">';
      document.body.appendChild(lightbox);
      lightbox.addEventListener('click', function () { lightbox.close(); });
    }
    var img = lightbox.querySelector('img');
    img.src = src;
    img.alt = alt || '';
    if (typeof lightbox.showModal === 'function') lightbox.showModal();
    else lightbox.setAttribute('open', '');
  }

  /* ------------------------------------------------------------------
     Gallery
     ------------------------------------------------------------------ */
  function initGallery(gallery) {
    if (!gallery || gallery.dataset.ready) return;
    gallery.dataset.ready = '1';
    var track = $('[data-gallery-track]', gallery);
    if (!track) return;
    var slides = $$('.gallery__slide', track);
    var thumbs = $$('[data-gallery-thumb]', gallery);
    var counter = $('[data-gallery-current]', gallery);
    var index = 0;

    function setActive(i) {
      index = i;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === i); });
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
      if (counter) counter.textContent = i + 1;
    }

    function goTo(i, smooth) {
      var target = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[target].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      setActive(target);
    }

    var frame;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        if (i !== index && slides[i]) setActive(i);
      });
    }, { passive: true });

    thumbs.forEach(function (thumb, n) { thumb.addEventListener('click', function () { goTo(n); }); });
    var prev = $('[data-gallery-prev]', gallery);
    var next = $('[data-gallery-next]', gallery);
    if (prev) prev.addEventListener('click', function () { goTo(index - 1); });
    if (next) next.addEventListener('click', function () { goTo(index + 1); });

    track.addEventListener('click', function (event) {
      var zoom = event.target.closest('[data-gallery-zoom]');
      if (!zoom) return;
      var img = zoom.querySelector('img');
      openLightbox(zoom.getAttribute('data-gallery-zoom'), img ? img.alt : '');
    });

    gallery.goToMedia = function (mediaId) {
      var n = slides.findIndex(function (s) { return s.dataset.mediaId === String(mediaId); });
      if (n > -1) goTo(n);
    };
  }

  /* ------------------------------------------------------------------
     Product (variants, quantity, add to cart, sticky bar)
     ------------------------------------------------------------------ */
  function initProduct(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';

    var json = $('[data-product-variants]', root);
    var variants = [];
    try { variants = JSON.parse(json ? json.textContent : '[]'); } catch (e) { variants = []; }

    var form = $('[data-product-form]', root);
    var idInput = form ? $('[data-variant-id]', form) : null;
    var picker = $('[data-variant-picker]', root);
    var addButton = $('[data-add-button]', root);
    var addLabel = $('[data-add-label]', root);
    var addPrice = $('[data-add-price]', root);
    var errorBox = $('[data-form-error]', root);
    var sticky = $('[data-sticky-atc]', root);
    var gallery = $('[data-gallery]', root);
    var updateUrl = root.dataset.updateUrl === 'true';

    initGallery(gallery);

    function selectedOptions() {
      if (!picker) return [];
      return $$('fieldset[data-option-index]', picker).map(function (fieldset) {
        var checked = $('input:checked', fieldset);
        return checked ? checked.value : null;
      });
    }

    function findVariant(options) {
      return variants.find(function (variant) {
        return variant.options.every(function (value, i) { return value === options[i]; });
      });
    }

    function updateAvailability() {
      if (!picker) return;
      var current = selectedOptions();
      $$('fieldset[data-option-index]', picker).forEach(function (fieldset) {
        var position = parseInt(fieldset.dataset.optionIndex, 10);
        $$('[data-option-input]', fieldset).forEach(function (input) {
          var options = current.slice();
          options[position] = input.value;
          var match = findVariant(options);
          var label = input.closest('label');
          if (label) label.classList.toggle('is-unavailable', !match || !match.available);
        });
      });
    }

    function setText(el, value) {
      if (!el) return;
      el.textContent = value || '';
      el.hidden = !value;
    }

    function renderVariant(variant) {
      if (!addButton) return;
      if (!variant) {
        addButton.disabled = true;
        if (addLabel) addLabel.textContent = theme.strings.unavailable;
        return;
      }
      if (idInput) idInput.value = variant.id;

      var price = $('[data-price]', root);
      if (price) {
        var current = $('[data-price-current]', price);
        if (current) current.textContent = variant.price;
        setText($('[data-price-compare]', price), variant.compare);
        setText($('[data-price-badge]', price), variant.save);
        price.classList.toggle('price--sale', !!variant.compare);
      }
      setText($('[data-price-omnibus]', root), variant.omnibus);

      addButton.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? theme.strings.addToCart : theme.strings.soldOut;
      if (addPrice) addPrice.textContent = variant.price;

      if (sticky) {
        var stickyVariant = $('[data-sticky-variant]', sticky);
        var stickyButton = $('[data-sticky-button]', sticky);
        var stickyImage = $('[data-sticky-image]', sticky);
        $$('[data-sticky-price]', sticky).forEach(function (el) { el.textContent = variant.price; });
        if (stickyVariant) stickyVariant.textContent = variant.title;
        if (stickyButton) stickyButton.disabled = !variant.available;
        $$('[data-sticky-label]', sticky).forEach(function (el) {
          el.textContent = variant.available ? (el.dataset.label || el.textContent) : theme.strings.soldOut;
        });
        if (stickyImage) {
          // cut-out of the sleeve in the chosen colour, or the variant's own photo for unknown colours
          var thumb = stickyThumbs[colorKey(variant.options)];
          var src = thumb || variant.image;
          if (src) {
            stickyImage.src = src;
            stickyImage.removeAttribute('srcset');
            stickyImage.classList.toggle('is-cutout', !!thumb);
          }
        }
      }

      if (variant.media && gallery && gallery.goToMedia) gallery.goToMedia(variant.media);

      if (updateUrl && window.history.replaceState) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) { /* URL can't be updated in this context */ }
      }

      document.dispatchEvent(new CustomEvent('noirelle:variant-change', { detail: { variant: variant, root: root } }));
    }

    var stickyThumbs = {};
    if (sticky) {
      try { stickyThumbs = JSON.parse($('[data-sticky-thumbs]', sticky).textContent) || {}; } catch (e) { stickyThumbs = {}; }
    }

    if (picker) {
      picker.addEventListener('change', function (event) {
        var input = event.target;
        if (!input.matches('[data-option-input]')) return;
        var fieldset = input.closest('fieldset');
        $$('label', fieldset).forEach(function (l) { l.classList.toggle('is-selected', l.contains(input)); });
        var valueLabel = $('[data-selected-value]', fieldset);
        if (valueLabel) valueLabel.textContent = input.value;
        renderVariant(findVariant(selectedOptions()));
        updateAvailability();
      });
      updateAvailability();
    }

    root.addEventListener('click', function (event) {
      var minus = event.target.closest('[data-quantity-minus]');
      var plus = event.target.closest('[data-quantity-plus]');
      if (!minus && !plus) return;
      var input = $('input', event.target.closest('[data-quantity]'));
      var value = (parseInt(input.value, 10) || 1) + (plus ? 1 : -1);
      input.value = Math.min(99, Math.max(1, value));
    });

    if (form) {
      form.addEventListener('submit', function (event) {
        if (theme.cartType !== 'drawer' || !$('[data-cart-drawer]')) return;
        event.preventDefault();
        if (!addButton || addButton.disabled) return;
        if (errorBox) errorBox.hidden = true;
        addButton.classList.add('is-loading');
        addButton.setAttribute('aria-busy', 'true');
        var original = addLabel ? addLabel.textContent : '';
        if (addLabel) addLabel.textContent = theme.strings.adding;
        cart.add(new FormData(form))
          .then(function (data) {
            cart.render(data.sections);
            openDrawer('CartDrawer');
          })
          .catch(function (error) {
            if (errorBox) {
              errorBox.textContent = error.message || theme.strings.error;
              errorBox.hidden = false;
            }
          })
          .finally(function () {
            addButton.classList.remove('is-loading');
            addButton.removeAttribute('aria-busy');
            if (addLabel) addLabel.textContent = original;
          });
      });
    }

    // Shown once the main button has scrolled out above the screen, hidden again over the footer.
    // Measured on scroll (one read per frame) so jumps past the button (anchor links, fast flicks) count too.
    if (sticky && addButton) {
      var stickyButtonEl = $('[data-sticky-button]', sticky);
      var footer = $('.site-footer');
      var shown = null;
      var ticking = false;
      var updateSticky = function () {
        ticking = false;
        var b = addButton.getBoundingClientRect();
        var pastButton = b.height > 0 && b.bottom < 0;
        var footerVisible = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
        var visible = pastButton && !footerVisible;
        if (visible === shown) return;
        shown = visible;
        sticky.classList.toggle('is-visible', visible);
        sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
        if (stickyButtonEl) stickyButtonEl.tabIndex = visible ? 0 : -1;
      };
      var requestSticky = function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(updateSticky);
      };
      window.addEventListener('scroll', requestSticky, { passive: true });
      window.addEventListener('resize', requestSticky);
      updateSticky();
    }
  }

  /* ------------------------------------------------------------------
     Estimated delivery (business days, cut-off hour)
     ------------------------------------------------------------------ */
  function addBusinessDays(date, days) {
    var d = new Date(date.getTime());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6) added += 1;
    }
    return d;
  }

  function initDelivery(root) {
    var cfg = theme.delivery || {};
    if (!cfg.enabled) return;
    $$('[data-delivery-text]', root).forEach(function (el) {
      var template = el.getAttribute('data-template');
      if (!template || template.indexOf('[start]') === -1) return;
      var now = new Date();
      var start = new Date(now.getTime());
      if (now.getHours() >= (cfg.cutoff == null ? 14 : cfg.cutoff)) start.setDate(start.getDate() + 1);
      var min = parseInt(cfg.min, 10) || 3;
      var max = Math.max(min, parseInt(cfg.max, 10) || min);
      var lang = (document.documentElement.lang || 'en').toLowerCase();
      if (lang === 'en') lang = 'en-GB';
      var formatter;
      try {
        formatter = new Intl.DateTimeFormat(lang, { weekday: 'short', day: 'numeric', month: 'short' });
      } catch (e) {
        formatter = new Intl.DateTimeFormat('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
      }
      var values = { start: formatter.format(addBusinessDays(start, min)), end: formatter.format(addBusinessDays(start, max)) };
      el.textContent = '';
      template.split(/(\[start\]|\[end\])/).forEach(function (part) {
        if (part === '[start]' || part === '[end]') {
          var strong = document.createElement('strong');
          strong.textContent = values[part.slice(1, -1)];
          el.appendChild(strong);
        } else if (part) {
          el.appendChild(document.createTextNode(part));
        }
      });
    });
  }

  /* ------------------------------------------------------------------
     Colour story
     ------------------------------------------------------------------ */
  function initColorStory(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var tabs = $$('[data-color-tab]', root);
    var images = $$('[data-color-image]', root);
    var panels = $$('[data-color-panel]', root);
    var active = 0;

    function activate(i) {
      if (!tabs[i]) return;
      active = i;
      tabs.forEach(function (tab, n) {
        var on = n === i;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
      });
      images.forEach(function (img, n) { img.classList.toggle('is-active', n === i); });
      panels.forEach(function (panel, n) {
        panel.hidden = n !== i;
        panel.classList.toggle('is-active', n === i);
      });
      var tint = tabs[i].dataset.tint;
      if (tint) root.style.setProperty('--tint', tint);
    }
    root.activateColor = activate;

    tabs.forEach(function (tab, n) {
      tab.tabIndex = n === 0 ? 0 : -1;
      tab.addEventListener('click', function () { activate(n); });
      tab.addEventListener('mouseenter', function () {
        if (mq('(hover: hover) and (min-width: 990px)')) activate(n);
      });
      tab.addEventListener('keydown', function (event) {
        var key = event.key;
        if (['ArrowDown', 'ArrowRight', 'ArrowUp', 'ArrowLeft'].indexOf(key) === -1) return;
        event.preventDefault();
        var dir = key === 'ArrowDown' || key === 'ArrowRight' ? 1 : -1;
        var next = (active + dir + tabs.length) % tabs.length;
        activate(next);
        tabs[next].focus();
      });
    });

    root.addEventListener('click', function (event) {
      var button = event.target.closest('[data-color-select]');
      if (!button) return;
      var value = (button.getAttribute('data-color-select') || '').toLowerCase();
      var product = $('[data-product]');
      if (!product) return;
      var input = $$('[data-option-input]', product).find(function (el) { return el.value.toLowerCase() === value; });
      if (!input) return;
      event.preventDefault();
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      product.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    document.addEventListener('noirelle:variant-change', function (event) {
      var options = (event.detail.variant.options || []).map(function (o) { return String(o).toLowerCase(); });
      tabs.forEach(function (tab, n) {
        var name = tab.querySelector('.color-story__name');
        if (name && options.indexOf(name.textContent.trim().toLowerCase()) > -1 && n !== active) activate(n);
      });
    });
  }

  /* ------------------------------------------------------------------
     EU withdrawal form (two steps)
     ------------------------------------------------------------------ */
  function initWithdrawal(form) {
    if (form.dataset.ready) return;
    form.dataset.ready = '1';
    var step1 = $('[data-step="1"]', form);
    var step2 = $('[data-step="2"]', form);
    if (!step1 || !step2) return;
    form.setAttribute('novalidate', 'novalidate');
    var indicators = $$('[data-step-indicator]', form);
    var itemsField = $('[data-items-field]', form);
    var phoneField = $('[data-phone-field]', form);
    var body = $('[data-withdrawal-body]', form);

    form.addEventListener('change', function (event) {
      var t = event.target;
      if (t.matches('[data-scope]') && itemsField) {
        var part = t.dataset.scope === 'part' && t.checked;
        itemsField.hidden = !part;
        $('textarea', itemsField).required = part;
      }
      if (t.matches('[data-contact]') && phoneField) {
        var phone = t.dataset.contact === 'phone' && t.checked;
        phoneField.hidden = !phone;
        $('input', phoneField).required = phone;
      }
    });

    function showStep(n) {
      step1.hidden = n !== 1;
      step2.hidden = n !== 2;
      indicators.forEach(function (li) { li.classList.toggle('is-active', li.dataset.stepIndicator === String(n)); });
      form.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    $('[data-step-next]', form).addEventListener('click', function () {
      var firstInvalid = null;
      $$('input, textarea', step1).forEach(function (el) {
        if (el.type === 'radio' || el.closest('[hidden]')) return;
        el.classList.remove('is-invalid');
        var old = el.parentElement.querySelector('.field__error');
        if (old) old.remove();
        var message = '';
        if (el.required && !el.value.trim()) message = theme.strings.required;
        else if (el.type === 'email' && el.value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(el.value.trim())) message = theme.strings.invalidEmail;
        if (message) {
          el.classList.add('is-invalid');
          var error = document.createElement('p');
          error.className = 'field__error';
          error.textContent = message;
          el.insertAdjacentElement('afterend', error);
          if (!firstInvalid) firstInvalid = el;
        }
      });
      if (firstInvalid) { firstInvalid.focus(); return; }

      var summary = $('[data-summary]', form);
      var statement = $('[data-statement]', form);
      summary.textContent = '';
      var lines = [statement ? statement.textContent.trim() : '', ''];
      $$('[data-summary-label]', step1).forEach(function (el) {
        if (el.closest('[hidden]')) return;
        if (el.type === 'radio' && !el.checked) return;
        var value = el.value.trim();
        if (!value) return;
        var dt = document.createElement('dt');
        dt.textContent = el.dataset.summaryLabel;
        var dd = document.createElement('dd');
        dd.textContent = value;
        summary.appendChild(dt);
        summary.appendChild(dd);
        lines.push(el.dataset.summaryLabel + ': ' + value);
      });
      lines.push('', 'Submitted (customer device time): ' + new Date().toString());
      if (body) body.value = lines.join('\n');
      showStep(2);
    });

    $('[data-step-back]', form).addEventListener('click', function () { showStep(1); });
  }

  /* ------------------------------------------------------------------
     Sleeve animation (size section)
     ------------------------------------------------------------------ */
  var COLOR_WORDS = {
    noir: ['noir', 'black', 'czarn', 'schwarz', 'nero', 'negro'],
    emeraude: ['emeraude', 'emerald', 'green', 'zielon', 'vert', 'grun', 'verde'],
    bordeaux: ['bordeaux', 'burgund', 'bordow', 'wine', 'red', 'czerwon'],
    cognac: ['cognac', 'koniak', 'brown', 'brazow', 'braun', 'marron', 'tan', 'camel'],
    rose: ['rose', 'pink', 'rozow', 'rosa', 'blush']
  };
  function colorKey(values) {
    var list = [].concat(values || []);
    for (var i = 0; i < list.length; i++) {
      var v = String(list[i]).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      for (var key in COLOR_WORDS) {
        if (COLOR_WORDS[key].some(function (w) { return v.indexOf(w) > -1; })) return key;
      }
    }
    return null;
  }

  function initFitAnim(el) {
    if (el.dataset.ready) return;
    el.dataset.ready = '1';

    if ('IntersectionObserver' in window) {
      el.classList.add('is-offscreen');
      new IntersectionObserver(function (entries) {
        el.classList.toggle('is-offscreen', !entries[0].isIntersecting);
      }, { threshold: 0.15 }).observe(el);
    }

    var toggle = $('[data-fit-toggle]', el);
    if (toggle) {
      toggle.addEventListener('click', function () {
        var paused = el.classList.toggle('is-paused');
        toggle.setAttribute('aria-pressed', paused ? 'true' : 'false');
        toggle.setAttribute('aria-label', paused ? toggle.dataset.labelPlay : toggle.dataset.labelPause);
      });
    }

    if (el.dataset.follow !== 'true') return;
    var urls = {};
    try { urls = JSON.parse($('[data-fit-colors]', el).textContent); } catch (e) { urls = {}; }
    var wanted = el.dataset.color;

    // every photo layer of the new colour is loaded first, then all are swapped in the same frame
    function apply(key) {
      if (!key || !urls[key] || key === wanted) return;
      wanted = key;
      var layers = $$('[data-fit-layer]', el);
      var pending = layers.length;
      var done = function () {
        pending -= 1;
        if (pending > 0 || wanted !== key) return;
        layers.forEach(function (img) {
          var src = urls[key][img.dataset.fitLayer];
          if (src) img.src = src;
        });
        el.dataset.color = key;
      };
      layers.forEach(function (layer) {
        var img = new Image();
        img.onload = img.onerror = done;
        img.src = urls[key][layer.dataset.fitLayer] || layer.src;
      });
    }

    document.addEventListener('noirelle:variant-change', function (event) {
      apply(colorKey(event.detail.variant.options));
    });
    var product = $('[data-product]');
    if (product) {
      apply(colorKey($$('[data-option-input]:checked', product).map(function (input) { return input.value; })));
    }
  }

  /* ------------------------------------------------------------------
     Reveal on scroll
     ------------------------------------------------------------------ */
  var revealObserver = null;
  function initReveal(root) {
    var elements = $$('[data-reveal]:not(.is-revealed)', root);
    var animate = document.documentElement.classList.contains('has-animations') && 'IntersectionObserver' in window &&
      !(window.Shopify && window.Shopify.designMode) && !mq('(prefers-reduced-motion: reduce)');
    if (!animate) {
      elements.forEach(function (el) { el.classList.add('is-revealed'); });
      $$('.material', root).forEach(function (el) { el.classList.add('is-in-view'); });
      return;
    }
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add(entry.target.classList.contains('material') ? 'is-in-view' : 'is-revealed');
          revealObserver.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    }
    elements.forEach(function (el) {
      var siblings = Array.prototype.filter.call(el.parentElement.children, function (c) { return c.hasAttribute('data-reveal'); });
      var position = siblings.indexOf(el);
      if (position > 0) el.style.transitionDelay = Math.min(position, 5) * 90 + 'ms';
      revealObserver.observe(el);
    });
    $$('.material:not(.is-in-view)', root).forEach(function (el) { revealObserver.observe(el); });
  }

  /* ------------------------------------------------------------------
     Misc
     ------------------------------------------------------------------ */
  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-autosubmit]') && event.target.form) event.target.form.submit();
  });

  function init(root) {
    root = root || document;
    initAnnouncement(root);
    $$('[data-product]', root).forEach(initProduct);
    $$('[data-color-story]', root).forEach(initColorStory);
    $$('[data-withdrawal-form]', root).forEach(initWithdrawal);
    $$('[data-fit-anim]', root).forEach(initFitAnim);
    initDelivery(root);
    initReveal(root);
  }

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:block:select', function (event) {
    var story = event.target.closest('[data-color-story]');
    if (story && story.activateColor) {
      var image = event.target.closest('[data-color-image]');
      if (image) story.activateColor(parseInt(image.dataset.colorImage, 10));
    }
  });
  document.addEventListener('shopify:section:select', function (event) {
    if (event.target.querySelector('[data-cart-drawer]')) openDrawer('CartDrawer');
  });
  document.addEventListener('shopify:section:deselect', function (event) {
    if (event.target.querySelector('[data-cart-drawer]')) closeDrawer(document.getElementById('CartDrawer'));
  });

  function start() {
    initHeader();
    init(document);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
